export default "__VITE_ASSET__Cb7JoGSm__"